import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Json } from "@/integrations/supabase/types";

export interface HomepageSection {
  id: string;
  section_key: string;
  section_title: string;
  section_title_ar: string | null;
  subtitle: string | null;
  subtitle_ar: string | null;
  description: string | null;
  description_ar: string | null;
  content: Json | null;
  content_ar: Json | null;
  display_order: number | null;
  is_active: boolean;
}

export const useHomepageSections = () => {
  const [sections, setSections] = useState<HomepageSection[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSections = async () => {
      const { data, error } = await supabase
        .from('homepage_sections')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) {
        console.log('Error fetching homepage sections:', error.message);
        setLoading(false);
        return;
      }

      setSections(data || []);
      setLoading(false);
    };

    fetchSections();
  }, []);

  const getSection = (key: string): HomepageSection | undefined => {
    return sections.find(s => s.section_key === key);
  };

  const getSectionContent = (key: string, contentKey: string): string => {
    const section = getSection(key);
    if (section?.content && typeof section.content === 'object' && !Array.isArray(section.content)) {
      return String((section.content as Record<string, unknown>)[contentKey] || '');
    }
    return '';
  };

  return { sections, loading, getSection, getSectionContent };
};
